
























import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import Loading from '@/components/Loading.vue'
import {timeSince} from '@/utils/time'
import {Action} from 'vuex-class'
import {IMessage} from '@/entities/notices'
import {embedded, postMessageToRNWebView} from '@/utils/react-native-webview'
import vClickOutside from 'v-click-outside'
import NoticeTemplate from './NoticeTemplate.vue'
import DailyCheckIn from '@/components/Notices/DailyCheckIn.vue';


@Component<NoticeMessage>({
    components: {DailyCheckIn, NoticeTemplate, Loading},
    directives: {
        clickOutside: vClickOutside.directive
    },
    filters: {
        timeSince
    }
})
export default class NoticeMessage extends Vue {
    @Prop() private id !: number | string
    @Prop({type: String, default: 'received'}) private mailbox ?: string // [received | sent |scheduled]
    @Prop({type: String, default: 'message'}) private messageType ?: string // [check-in | message]

    @Prop() private message!: IMessage

    @Action private loadMessage

    private async mounted() {
        if (!this.message) {
            await this.loadMessage(Number(this.id))
        }
    }

    private async onClose() {
        await this.$emit('close')
        if (embedded) {
            postMessageToRNWebView({
                action: 'back' // tell react native to go back
            })
        }
    }

    private clickedOutside() {
        if (this.message.seen || this.mailbox !== 'received') {
            this.onClose()
        }
    }
}

